import './styles/index.css';
import './styles/common.css';
import './config/i18nConfig'; // Initialize i18n

import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { store, persistor } from './store/configureStore';
import { initGlobalErrorHandlers } from './errors/globalErrorHandlers';

import AppContextProvider from './contexts/AppContextProvider';
import { ThemeProvider } from './contexts/ThemeContext';
import App from './App';
import LoadingFallback from './components/LoadingFallback';

// Install global error & session-expiry listeners BEFORE rendering
initGlobalErrorHandlers();

const root = createRoot(document.getElementById('root')!);

root.render(
    <Suspense fallback={<LoadingFallback />}>
        <ReduxProvider store={store}>
            <PersistGate loading={<LoadingFallback />} persistor={persistor}>
                <ThemeProvider>
                    <AppContextProvider>
                        <App />
                    </AppContextProvider>
                </ThemeProvider>
            </PersistGate>
        </ReduxProvider>
    </Suspense>
);